module.exports = __webpack_public_path__ + "static/events@2x-da2ce02aba8ed9dca8451e3dd7efc459.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/resources/events@2x.png
// module id = 2686
// module chunks = 157636680307020